'use client'
import React, { useEffect, useState } from 'react'
import { useLanguage } from '../contexts/LanguageContext' // Sizning custom hook'ingiz

const Footer = () => {
    const { t } = useLanguage() // Custom hook'dan t funksiyasini olish
    const [isClient, setIsClient] = useState(false)

    useEffect(() => {
        setIsClient(true)
    }, [])

    // Client-side rendering kutish
    if (!isClient) {
        return null
    }

    return (
        <footer className='bg-[#272727] py-6 border-t-4'>
            <div className='max-w-7xl mx-auto px-6'>
                {/* Desktop Layout */}
                <div className='hidden md:flex justify-between items-center'>
                    {/* Left: Logo */}
                    <div className='flex items-center'>
                        <img className='w-[108px]' src="/logo.png" alt="JAC Forklift Logo" />
                    </div>

                    {/* Center: Copyright */}
                    <div className='text-center'>
                        <p className='text-gray-300 text-sm'>
                            JAC Forklift © 2025. {t.all_rights_reserved}
                        </p>
                    </div>

                    {/* Right: Contact Info */}
                    <div className='flex items-center gap-6'>
                        {/* Phone */}
                        <a
                            href="tel:+998949876000"
                            className='text-gray-300 hover:text-white transition-colors duration-200 flex items-center gap-2'
                        >
                            <svg className='w-5 h-5' fill='currentColor' viewBox='0 0 20 20'>
                                <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                            </svg>
                            <span className='text-sm font-medium'>
                                {'+998 94 987 60 00'}
                            </span>
                        </a>

                        {/* Social Icons */}
                        <div className='flex items-center gap-3'>
                            {/* Telegram */}
                            <a
                                href="https://t.me/+998949876000"
                                target="_blank"
                                rel="noopener noreferrer"
                                className='text-gray-400 hover:text-blue-400 transition-colors duration-200'
                                aria-label={t.telegram_channel}
                            >
                                <svg className='w-6 h-6' fill='currentColor' viewBox='0 0 24 24'>
                                    <path d='M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z' />
                                </svg>
                            </a>

                            {/* Instagram */}
                            <a
                                href="https://instagram.com/jacforklift.uz"
                                target="_blank"
                                rel="noopener noreferrer"
                                className='text-gray-400 hover:text-pink-400 transition-colors duration-200'
                                aria-label={t.instagram_page}
                            >
                                <svg className='w-6 h-6' fill='currentColor' viewBox='0 0 24 24'>
                                    <path d='M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z' />
                                </svg>
                            </a>

                            {/* YouTube */}
                            <a
                                href="https://youtube.com/@jacforklift"
                                target="_blank"
                                rel="noopener noreferrer"
                                className='text-gray-400 hover:text-red-500 transition-colors duration-200'
                                aria-label={t.youtube_channel}
                            >
                                <svg className='w-6 h-6' fill='currentColor' viewBox='0 0 24 24'>
                                    <path d='M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z' />
                                </svg>
                            </a>

                            {/* Facebook */}
                            <a
                                href="https://facebook.com/jacforklift.uz"
                                target="_blank"
                                rel="noopener noreferrer"
                                className='text-gray-400 hover:text-blue-600 transition-colors duration-200'
                                aria-label={t.facebook_page}
                            >
                                <svg className='w-6 h-6' fill='currentColor' viewBox='0 0 24 24'>
                                    <path d='M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z' />
                                </svg>
                            </a>
                        </div>
                    </div>
                </div>

                {/* Mobile Layout */}
                <div className='md:hidden flex flex-col space-y-4'>
                    {/* Logo and Phone in one line */}
                    <div className='flex justify-between items-center'>
                        {/* Logo */}
                        <div className='flex items-center'>
                            <img className='w-[80px]' src="/logo.png" alt="JAC Forklift Logo" />
                        </div>

                        {/* Phone */}
                        <a
                            href="tel:+998949876000"
                            className='text-gray-300 hover:text-white transition-colors duration-200 flex items-center gap-2'
                        >
                            <svg className='w-5 h-5' fill='currentColor' viewBox='0 0 20 20'>
                                <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                            </svg>
                            <span className='text-sm font-medium'>
                                {t.call}
                            </span>
                        </a>
                    </div>

                    {/* Social Icons */}
                    <div className='flex justify-center items-center gap-4'>
                        {/* Telegram */}
                        <a
                            href="https://t.me/+998949876000"
                            target="_blank"
                            rel="noopener noreferrer"
                            className='text-gray-400 hover:text-blue-400 transition-colors duration-200'
                            aria-label={t.telegram_channel}
                        >
                            <svg className='w-6 h-6' fill='currentColor' viewBox='0 0 24 24'>
                                <path d='M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z' />
                            </svg>
                        </a>

                        {/* Instagram */}
                        <a
                            href="https://instagram.com/jacforklift.uz"
                            target="_blank"
                            rel="noopener noreferrer"
                            className='text-gray-400 hover:text-pink-400 transition-colors duration-200'
                            aria-label={t.instagram_page}
                        >
                            <svg className='w-6 h-6' fill='currentColor' viewBox='0 0 24 24'>
                                <path d='M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.40z' />
                            </svg>
                        </a>

                        {/* YouTube */}
                        <a
                            href="https://youtube.com/@jacforklift"
                            target="_blank"
                            rel="noopener noreferrer"
                            className='text-gray-400 hover:text-red-500 transition-colors duration-200'
                            aria-label={t.youtube_channel}
                        >
                            <svg className='w-6 h-6' fill='currentColor' viewBox='0 0 24 24'>
                                <path d='M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z' />
                            </svg>
                        </a>

                        {/* Facebook */}
                        <a
                            href="https://facebook.com/jacforklift.uz"
                            target="_blank"
                            rel="noopener noreferrer"
                            className='text-gray-400 hover:text-blue-600 transition-colors duration-200'
                            aria-label={t.facebook_page}
                        >
                            <svg className='w-6 h-6' fill='currentColor' viewBox='0 0 24 24'>
                                <path d='M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z' />
                            </svg>
                        </a>
                    </div>

                    {/* Copyright */}
                    <div className='text-center'>
                        <p className='text-gray-300 text-sm'>
                            JAC Forklift © 2025. {t.all_rights_reserved}
                        </p>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer